<template>
  <div>
    <div>
      <v-layout row wrap>
        <v-flex xs12>
          <WsHeader :theme="false" :date="full_date" />
        </v-flex>
        <v-flex d-flex md12>
          <Toolbar>
            <v-flex sm4>
              <span class="body-2">{{ $t('Tracker') }}</span>
              <span class="Subtitle 2">
                {{ `[ ${selectedBlockId && selectedBlockId.text} ]` }}
              </span>
            </v-flex>
            <v-flex sm8 text-sm-right>
              <div class="body-1">
                {{ show_date }}
              </div>
            </v-flex>
          </Toolbar>
        </v-flex>
        <v-flex md12 d-flex>
          <Card class="tablediv pa-2">
            <v-layout v-for="item in trackerData" :key="item.name" class="card-separation">
              <v-flex md12>
                <div class="img-text">{{ $t('Name')}} : {{item.name}}</div>
                <Card class="outside-card bg pa-2">
                  <v-layout ma-0>
                    <v-flex md12>
                      <Card v-for="(subItem,id) in item.array" class="inside-card ma-0 pa-0" :key="id">
                        <v-layout class="inside-card-separation primary">
                          <v-flex md12 d-flex>
                            <v-flex md6 lg6 xl6>
                              <v-layout row wrap pa-1 ma-1>
                                <template v-for="(data, header, idx) in subItem">
                                  <v-flex md4 class="scb_header"
                                    :key="idx" v-if="header !== 'ClickAble'">
                                      {{ $t(header) }} :
                                      <span v-if="data == null" class="scb_data">NA</span>
                                      <span v-else class="scb_data"> {{data}} </span>
                                  </v-flex>
                                </template>
                              </v-layout>
                            </v-flex>
                            <v-divider vertical></v-divider>
                            <v-flex md6 lg6 xl6 class="scb-channel-data">
                              <div class="channel-wrapper">
                                <div class="elevation-2"
                                  v-for="(value,key, index) in subItem.ClickAble" :key="id+index">
                                  <h4
                                    v-bind:class="isActive[`${id}-${key}`] ? 'ch-selected' : 'card-box'"
                                    v-on:click="channelClicked(`${id}-${key}`)">
                                    <span> {{ key }} : </span>
                                    <span v-if="value == null || value == Infinity"> {{ $t('No Data') }}</span>
                                    <span v-else> {{ value }} </span>
                                  </h4>
                                </div>
                              </div>
                            </v-flex>
                          </v-flex>
                          <v-divider horizontal></v-divider>
                        </v-layout>
                      </Card>
                    </v-flex>
                  </v-layout>
                </Card>
              </v-flex>
            </v-layout>
          </Card>
        </v-flex>
      </v-layout>
      <div class="text-xs-center">
        <v-btn class="info" @click="showGraph()">{{ $t('Show Graph') }}</v-btn>
        <v-btn class="info" @click="clearAll()">{{ $t('Clear All') }}</v-btn>
      </div>
    </div>
    <GlobalGraph v-show="graphActive" class="graph" :series="bar.series" :xAxis="bar.xAxis" :yAxis="bar.yAxis"
      :theme="theme" />
  </div>
</template>

<script>
const momentTz = require('moment-timezone')
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import TrackerService from '@/services/tracker'
import CommonApi from '@/services/Common'
import IEcharts from 'vue-echarts-v3/src/full.js'
import { mapGettersMixin } from '@/util/mixin/index'

const WsHeader = () => import('@/components/tracker/Header')

export default {
  mixins: [ mapGettersMixin ],
  components: {
    IEcharts,
    WsHeader
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      enableWatch: false,
      activeParam: {},
      rotationAngle: {},
      loading: false,
      graphActive: false,
      isActive: {},
      trackerData: [],
      bar: {
        xAxis: {
          data: []
        },
        yAxis: [{
          name: 'Angle (°)',
          axisLabel: {
            formatter: '{value}',
            rotate: 40
          }
        }],
        series: [],
      },
      blockList: [],
      trackerList: [],
      activeFilter: {}
    }
  },

  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantTimezone']),
    filter() {
      return [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          dependentId: "trackerList",
          id: "blockList",
          type: "select",
          title: "Select Block",
          value: this.blockList,
        },
        {
          ref: "blockList",
          id: "trackerList",
          type: "selectCombo",
          title: "Select Trackers",
          value: this.trackerList,
          condition: (ref) => {
            return !!(ref && ref.text);
          },
        },
      ]
    },
    full_date() {
      return this.activeFilter && this.activeFilter.Date != null ? this.activeFilter.Date.from : momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
    },
    show_date() {
      return moment(this.full_date).format('YYYY/M/D')
    },
    selectedBlockId() {
      return this.activeFilter && this.activeFilter.blockList != null ? this.activeFilter.blockList : []
    },
    selectedTrackers() {
      return this.activeFilter && this.activeFilter.trackerList != null ? this.activeFilter.trackerList : []
    },
    isUpdateData() {
      return `${this.selectedTrackers.map(el => el.modifiedId).join()}||${this.full_date}`
    }
  },
  async mounted() {
    await this.initialConfigList()
    await this.setIntervalWithoutDelay(this.callAllApi)
  },
  methods: {
    ...mapMutations(['SET_LAST_CALL_TIME', 'SET_PROGRESS_BAR', 'SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT']),
    async initialConfigList() {
      let blockListRes = await this.getBlockList()
      this.blockList = blockListRes.data.message

      let trackerListRes = await this.getTrackerList(this.blockList[0])
      this.trackerList = trackerListRes.data.message

      const Obj = {}
      const cloneFilterOption = _.cloneDeep(this.filter);
      cloneFilterOption.forEach(child => {
        if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
          if (child.type === 'select') {
            if (typeof child.value === 'function') {
              Obj[child.id] = child.value(Obj[child.ref])
            } else {
              Obj[child.id] = child.value[0]
            }
          } else if (child.type === 'singleDatePicker') {
            let parameters = ['from', 'to']
            parameters.forEach(key => {
              if (!Obj[child.id]) { Obj[child.id] = {} }
              Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
            })
          } else {
            Obj[child.id] = child.value
          }
        }
      })
      this.activeFilter = Obj;
      this.$emit("filter:config", cloneFilterOption);
      this.$emit('initial:active_filter', Obj)
    },
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true)
      this.SET_SNACKBAR_CONTENT(payload)
    },
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getTrackerTableData(this.selectedTrackers)
      if (this.graphActive) {
        this.showGraph()
      }
    },
    async getTrackerTableData(selectedTrackers) {
      try {
        this.SET_PROGRESS_BAR(true)
        let modifiedId = []
        selectedTrackers.forEach(el => {
          modifiedId.push(el.modifiedId)
        })
        const param = {
          'plantId': this.getSelectedPlantId,
          'modifiedId': modifiedId,
          'date': moment(this.full_date).format('YYYY-MM-DD')
        }
        const response = await TrackerService.fetchTrackerTableData(param)
        this.trackerData = response.data
        this.enableWatch = true
        this.SET_PROGRESS_BAR(false)
        Object.entries(this.trackerData).forEach(([key, value]) => {
          this.$set(this.rotationAngle, key, value.targetAngle)
          Object.entries(value.array).forEach(([id, data]) => {
            Object.keys(data.ClickAble).forEach((key1) => {
              this.isActive[`${id}-${key1}`] = this.isActive[`${id}-${key1}`] ? this.isActive[`${id}-${key1}`] : false
            })
          })
        })
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    },
    async getTrackerGraphData(modifiedId) {
      try {
        this.loading = true
        const param = {
          'plantId': this.getSelectedPlantId,
          'modifiedId': modifiedId,
          'date': moment(this.full_date).format('YYYY-MM-DD')
        }
        const response = await TrackerService.fetchTrackerGraphData(param)
        this.loading = false
        this.bar.series = []
        Object.keys(response.data.finalData).forEach(id => {
          this.bar.series.push({
            name: id,
            type: 'line',
            data: response.data.finalData[id]
          })
        })
        // this.bar.legend.data = response.data.legenData
        this.bar.xAxis.data = response.data.axis
        this.graphActive = true
      } catch (err) {
        this.bar.series = []
        // this.bar.legend.data = []
        this.bar.xAxis.data = []
        this.loading = false
      }
    },
    async getBlockList() {
      return new Promise(async (resolve, reject) => {
        let response = await CommonApi.getDeviceBlockList(this.getSelectedPlantId, 'tracker', 1, null);
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(new Error(response));
        }
      });
    },
    async getTrackerList(selectedBlock) {
      return new Promise(async (resolve, reject) => {
        const response = await CommonApi.getIdList(this.getSelectedPlantId, 'TRACKER', 2, selectedBlock['id']);
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(new Error(response));
        }
      });
    },
    channelClicked(id) {
      let state = !this.isActive[id]
      delete this.isActive[id]
      this.$set(this.isActive, id, state)
      let selectedChannels = Object.keys(this.isActive).filter(el => {
        if (this.isActive[el]) {
          return el
        }
      })
      if (selectedChannels.length === 0) {
        this.graphActive = false
      }
    },
    async showGraph() {
      let selectedChannels = Object.keys(this.isActive).filter(el => {
        if (this.isActive[el]) {
          return el
        }
      })
      let modifiedId = {}
      if (selectedChannels.length !== 0) {
        selectedChannels.forEach(el => {
          let id = el.slice(0, 4)
          let channelId = el.slice(0, 6)
          if (id[3] === '-') {
            id = id.slice(0, 3)
          }
          if (channelId[5] === '-') {
            channelId = channelId.slice(0, 5)
          }
          let chId = channelId.slice(-2).replace('-', '')
          if (!modifiedId.hasOwnProperty(id)) { modifiedId[id] = {} }
          if (el.includes('Target Angle') && !modifiedId[id].hasOwnProperty('target_angle')) { modifiedId[id]['target_angle'] = [] }
          if (el.includes('Actual Angle') && !modifiedId[id].hasOwnProperty('actual_angle')) { modifiedId[id]['actual_angle'] = [] }

          if (el.includes('Target Angle')) { modifiedId[id]['target_angle'].push(chId) }
          if (el.includes('Actual Angle')) { modifiedId[id]['actual_angle'].push(chId) }
        })
        await this.getTrackerGraphData(modifiedId)
        const el = document.querySelector('.graph')
        if (el) {
          el.scrollIntoView()
        }
      } else {
        this.updateSnackbar({
          icon: 'error',
          message: 'Please Select Any Component'
        })
      }
    },
    clearAll() {
      Object.keys(this.isActive).forEach(el => {
        this.$set(this.isActive, el, false)
      })
      this.graphActive = false
      this.bar.series = []
      this.bar.xAxis.data = []
    }
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    async getSelectedPlantId() {
      this.isActive = {}
      this.graphActive = false
      this.enableWatch = false
      await this.initialConfigList()
      await this.setIntervalWithoutDelay(this.callAllApi)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    },
    async selectedBlockId() {
      if (this.enableWatch) {
        const trackerListRes = await this.getTrackerList(this.selectedBlockId)
        this.trackerList = trackerListRes.data.message

        this.$set(this.activeFilter, 'inverterList', [this.trackerList])
        this.$emit("filter:config", _.cloneDeep(this.filter));
        this.$emit('initial:active_filter', this.activeFilter)
      }
    },
    isUpdateData() {
      if (this.enableWatch) {
        if (this.selectedTrackers.length === 0) {
          this.updateSnackbar({
            icon: 'error',
            message: 'Minimun one tracker will be selected'
          })
        } else {
          this.setIntervalWithoutDelay(this.callAllApi)
        }
      }
    }
  }
}
</script>

<style scoped>
.tablediv{
  height : calc(100vh - 372px);
  overflow-y: auto;
}

.ch-value_selected {
  border-style: solid !important;
  border-color: #818fff !important;
  border-width: thick !important;
  -webkit-animation: datals 1s infinite;
  -moz-animation: datals 1s infinite;
  -o-animation: datals 1s infinite;
  animation: datals 1s infinite;
}

.ch-selected {
  border-style: solid !important;
  border-color: #818fff !important;
  border-width: thick !important;
}

.graph {
	width: 100%;
	height: 400px;
}

h4 {
  min-width: 128px;
  margin: 4px;
  border-radius: 4px;
  min-height: 35px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.card-box {
  background: var(--v-primary-darken1);
}

.chisActive h4 {
  min-width: 128px;
  margin: 4px;
  border-radius: 4px;
  min-height: 35px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.channel-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(128px, 1fr));
}

.img-text {
  padding: 10px;
}
</style>
